
import { Vue, Component, PropSync, Watch, Prop } from "vue-property-decorator";
import { PredefinedDateRangeType } from "@/enumerations/Dates/DateRangePredefined/PredefinedDateRangeType";
import {
  getFormattedDateString,
  getPredefinedDateRangeStartDate,
  getPredefinedDateRangeEndDate,
  getCurrentDate,
} from "@/helpers/Dates/DateHelpers";

@Component
export default class DateRangePredefined extends Vue {
  @Prop({ required: false, default: false })
  includeAllDatesOption!: boolean;

  @PropSync("predefinedDateRangeType", { type: String })
  predefinedDateRangeTypeSync!: string;
  presetFromDate = getCurrentDate();
  presetToDate = getCurrentDate();

  get dateRangeTypes() {
    return Object.values(PredefinedDateRangeType).filter(
      (type) =>
        type !== PredefinedDateRangeType.AllDates || this.includeAllDatesOption
    );
  }

  mounted() {
    this.updateDateRange();
  }

  get dateRangeText() {
    return this.predefinedDateRangeTypeSync === PredefinedDateRangeType.AllDates
      ? ""
      : getFormattedDateString(this.presetFromDate) +
          " - " +
          getFormattedDateString(this.presetToDate);
  }

  @Watch("predefinedDateRangeTypeSync")
  updateDateRange(): void {
    this.presetToDate = getPredefinedDateRangeEndDate(
      getCurrentDate(),
      this.predefinedDateRangeTypeSync
    );
    this.presetFromDate = getPredefinedDateRangeStartDate(
      getCurrentDate(),
      this.predefinedDateRangeTypeSync
    );
  }
}
